import React from 'react';
import styled from 'styled-components/macro';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'src/client/redux';
import { FooterSeoSubHeadings } from './FooterSeoSubHeadings';
import { ConstrainedContainer, TABLET_PORTRAIT } from 'src/client/constants/mediaQueries';

export const FooterCompliance = () => {
  const { version: appVersion, config, ipLocation } = useSelector((state) => state.app);
  const siteDomain = useSelector((state) => state.site.domain);

  const year = new Date().getFullYear();
  const { customCompliance, url2257 } = config.footer;
  const isCalifornia = ipLocation.countryCode === 'US' && ipLocation.stateprovCode === 'CA';

  return (
    <Wrapper>
      <FooterSeoSubHeadings />
      <p>
        {url2257 ? (
          <a href={url2257}>18 U.S.C. 2257 Record-Keeping Requirements Compliance Statement.</a>
        ) : (
          <NavLink to="2257">18 U.S.C. 2257 Record-Keeping Requirements Compliance Statement.</NavLink>
        )}
        <br className="visible-xs" />
        <br />
        {isCalifornia && (
          <>
            <a
              href="https://help.metart.network/policies-rules/privacy-policy#PrivacyPolicy-UpdatingorDeletingYourPersonalInformation"
              target="_blank"
            >
              Do Not Sell or Share My Personal Information
            </a>
            <br className="visible-xs" />
            <br />
          </>
        )}
        Warning - This site contains adult material of a sexual nature - you must be of legal age in your area to view
        this material. <br />
        All materials on {siteDomain}, are copyright © {year} {siteDomain}. All models were at least 18 years of age
        when photographed. <br />
        Epoch is an authorized sales agent, their billing support may be found at{' '}
        <a href="https://epoch.com" target="_blank" rel="noopener noreferrer">
          Epoch.com
        </a>
        .<br />
        Segpay Billing Support can be accessed here:{' '}
        <a href="https://cs.segpay.com/" target="_blank" rel="noopener noreferrer">
          Segpay Consumer Portal
        </a>
        .
        {customCompliance && (
          <>
            <br />
            <span dangerouslySetInnerHTML={{ __html: customCompliance }} />
          </>
        )}
        <br />
        {appVersion}
      </p>
    </Wrapper>
  );
};

const Wrapper = styled(ConstrainedContainer)`
  margin: 0 auto;
  font-size: 0.9rem;
  padding: 10px;
  font-size: 0.7rem;
  line-height: 14px;
  text-align: center;
  color: ${(props) => props.theme.footerBarPrimary2};

  @media ${TABLET_PORTRAIT} {
    padding: 20px 15px;
    line-height: 20px;
  }

  a {
    text-decoration: none;
    color: ${(props) => props.theme.footerBarPrimary3};
  }
`;
